import { render, staticRenderFns } from "./CustomerSampleOrdersList.vue?vue&type=template&id=8a740aaa&scoped=true&"
import script from "./CustomerSampleOrdersList.vue?vue&type=script&lang=js&"
export * from "./CustomerSampleOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSampleOrdersList.vue?vue&type=style&index=0&id=8a740aaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a740aaa",
  null
  
)

export default component.exports